import React, { useState, useMemo,useEffect } from 'react';
import { BellOutlined, UserOutlined } from '@ant-design/icons';
import { Menu, Dropdown, Badge, List } from 'antd';
import { Link } from 'react-router-dom';
import MobileNav from './components/MobileNav';
import Nav from './components/Nav';
import logo from '../../assets/img/svg/ATC.svg';
import useAppHeader from '../AppHeader/logic/useAppHeader';

import './Navbar.scss';

const MOCK_DATA = [
  { id: 1, name: 'Yessin Rebhi', skills: ['JavaScript', 'React'], description: 'Frontend Developer and React expert.' },
  { id: 2, name: 'John Smith', skills: ['Python', 'Data Analysis'], description: 'Data Scientist with expertise in Python.' },
  { id: 3, name: 'Alice Johnson', skills: ['Project Management', 'Agile'], description: 'Experienced Project Manager and Agile coach.' },
];

const MOCK_NOTIFICATIONS = [
  { id: 1, title: 'Training Request Approved', description: 'Your training request for "Advanced SEO Techniques" has been approved.', type: 'success', date: '2024-09-10' },
  { id: 2, title: 'Training Request Rejected', description: 'Your training request for "Salesforce Masterclass" was rejected. Reason: Budget constraints.', type: 'error', date: '2024-09-11' },
  { id: 3, title: 'Training Request Pending', description: 'Your training request for "AWS Cloud Solutions" is still pending.', type: 'info', date: '2024-09-12' },
];

export default function Navbar() {
  const [scrollHeight, setScrollHeight] = useState(0);
  const [isMobileMenuActive, setIsMobileMenuActive] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isNotificationVisible, setNotificationVisible] = useState(false);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const { authenticatedUser } = useAppHeader();
  const { firstName, lastName, id, image } = authenticatedUser || {};

  useEffect(() => {
    const handleScroll = () => {
      setScrollHeight(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const profileImage = useMemo(() => {
    if (!image) return null;
    const imageUrl = `${process.env.REACT_APP_CORE_PATH}/users/avatars/${image}`;
    return imageUrl.split('/').pop() !== 'null' ? imageUrl : null;
  }, [image]);

  const ProfileMenu = () => (
    <Menu>
      {authenticatedUser ? (
        <>
          <Menu.Item key="user">{firstName} {lastName}</Menu.Item>
          <Menu.Item key="profile">
            <Link to={`/profile/${id}`}>Profile</Link>
          </Menu.Item>
          <Menu.Item key="logout">
            <Link to={`/logout/`}>Logout</Link>
          </Menu.Item>
        </>
      ) : (
        <>
          <Menu.Item key="login">
            <Link to="/login">Login</Link>
          </Menu.Item>
          <Menu.Item key="register">
            <Link to="/register">Register</Link>
          </Menu.Item>
        </>
      )}
    </Menu>
  );

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (value) {
      const filteredResults = MOCK_DATA.filter(item =>
        item.name.toLowerCase().includes(value.toLowerCase()) ||
        item.skills.some(skill => skill.toLowerCase().includes(value.toLowerCase()))
      );
      setSearchResults(filteredResults);
    } else {
      setSearchResults([]);
    }
  };

  const renderSearchResults = () => (
    searchResults.length > 0 ? (
      <div className="search-results">
        {searchResults.map(result => (
          <div key={result.id} className="search-result-item">
            <h4>{result.name}</h4>
            <p>{result.description}</p>
            <p><strong>Skills:</strong> {result.skills.join(', ')}</p>
          </div>
        ))}
      </div>
    ) : (
      <div className="search-results">
        <p>No results found.</p>
      </div>
    )
  );

  const NotificationMenu = () => (
    <div className="notifications">
      <List
        itemLayout="horizontal"
        dataSource={MOCK_NOTIFICATIONS}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta
              title={<span>{item.title}</span>}
              description={item.description}
            />
            <span className="notification-date">{item.date}</span>
          </List.Item>
        )}
      />
    </div>
  );

  return (
    <header
      id="header header-green header-fixed style-absolute"
      className={`header header-fixed style-absolute ${scrollHeight > 70 ? "is-fixed" : ""
        } ${scrollHeight > 100 ? "is-small" : ""}`}
    >
      <div className="header-inner">
        <div id="site-logo">
          <div id="site-logo-inner">
            <Link to="/" className="main-logo">
              <img
                id="logo_header"
                src={logo}
                width={90}
                alt=""
                height={"auto"}
              />
            </Link>
          </div>
        </div>
        {/* logo */}
        <nav id="main-nav" className="main-nav">
          <ul id="menu-primary-menu" className="menu-primary-menu">
            <Nav />
          </ul>
          <div id="header-search" className="header-search relative">
            <a onClick={() => setSearchActive(prev => !prev)} className="show-search">
              <i className="icon-search" />
            </a>
            <div className={`top-search ${searchActive ? "active" : ""}`}>
              <form onSubmit={(e) => e.preventDefault()} className="search-form relative">
                <fieldset className="search">
                  <input
                    type="search"
                    placeholder="Search..."
                    className="style-1"
                    value={searchTerm}
                    onChange={handleSearch}
                    required
                  />
                </fieldset>
                <i className="icon-search" />
              </form>
              {searchTerm && renderSearchResults()}
            </div>
          </div>
        </nav>
        {/* /#main-nav */}
        <div className="header-right">
          {authenticatedUser ? <div className='app-header-notification'>
            <Badge count={MOCK_NOTIFICATIONS.length}>
              <Dropdown
                overlay={<NotificationMenu />}
                trigger={['click']}
                open={isNotificationVisible}
                onOpenChange={(visible) => setNotificationVisible(visible)}
              >
                <BellOutlined className='icon' />
              </Dropdown>
            </Badge> 
          </div> : null}

          <div className='app-header-profile'>
            <Dropdown
              overlay={<ProfileMenu />}
              trigger={['click']}
              open={isDropdownVisible}
              onOpenChange={setDropdownVisible}
            >
              <div className="profile-button">
                {profileImage ? (
                  <img src={profileImage} className="profile-picture" alt="Profile" />
                ) : (
                  <UserOutlined />
                )}
              </div>
            </Dropdown>
          </div>

          <div
            onClick={() => setIsMobileMenuActive(true)}
            className="mobile-button hidden"
          >
            <span />
          </div>
        </div>
      </div>
      <div className={`mobile-nav-wrap ${isMobileMenuActive ? "active" : ""}`}>
        <div
          onClick={() => setIsMobileMenuActive(false)}
          className="overlay-mobile-nav"
        />
        <div className="inner-mobile-nav">
          <Link to="/" className="main-logo">
            <img
              id="mobile-logo_header"
              src={logo}
              width={90}
              alt=""
              height={"auto"}
            />
          </Link>
          <div
            onClick={() => setIsMobileMenuActive(false)}
            className="mobile-nav-close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              fill="white"
              x="0px"
              y="0px"
              width="20px"
              height="20px"
              viewBox="0 0 122.878 122.88"
              enableBackground="new 0 0 122.878 122.88"
              xmlSpace="preserve"
            >
              <g>
                <path d="M1.426,8.313c-1.901-1.901-1.901-4.984,0-6.886c1.901-1.902,4.984-1.902,6.886,0l53.127,53.127l53.127-53.127 c1.901-1.902,4.984-1.902,6.887,0c1.901,1.901,1.901,4.985,0,6.886L68.324,61.439l53.128,53.128c1.901,1.901,1.901,4.984,0,6.886 c-1.902,1.902-4.985,1.902-6.887,0L61.438,68.326L8.312,121.453c-1.901,1.902-4.984,1.902-6.886,0 c-1.901-1.901-1.901-4.984,0-6.886l53.127-53.128L1.426,8.313L1.426,8.313z" />
              </g>
            </svg>
          </div>
          <MobileNav />
        </div>
      </div>
    </header>
  );
}
